import { Injectable } from '@angular/core';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { Store } from '@ngrx/store';
import { UntypedFormGroup } from '@angular/forms';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { filter, take } from 'rxjs/operators';
import { _safe } from '../../../../../../shared/utils/safe-get.method';
import { ExperiencesService, TemperatureFeatures } from '../../../../../../shared/services/experiences.service';
import { getJobsiteSelected, OrderBuilderState } from '../../../../../reducers';
import { LoadTemperatureCatalogAction } from '../../../actions/single-catalogs.actions';
import { combineLatest } from 'rxjs';
import { SpecFieldNames } from '../../../../specification/constants/specification-field-names.enum';
@Injectable()
export class LoadSingleCatalogsTemperature implements OnFieldChanged {
  constructor(
    private experienceService: ExperiencesService,
    private store: Store<OrderBuilderState>,
  ) {}

  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    const jobSite = this.store.select(getJobsiteSelected).pipe(filter((jobsite) => !!jobsite));
    const isTemperaturaEnabled = this.experienceService.isTemperatureEnabled$().pipe(
      take(1),
      filter((feature) => feature != null),
    );

    combineLatest([jobSite, isTemperaturaEnabled]).subscribe(([jobsite, feature]) => {
      if (feature === TemperatureFeatures.NITRO) {
        const temperatureUnder = formGroup.get(SpecFieldNames.TEMPERATURE_UNDER);
        temperatureUnder.updateValueAndValidity();
      }
      return this.store.dispatch(
        new LoadTemperatureCatalogAction({
          feature,
          jobsite,
        }),
      );
    });
  }
}
